"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_element_base_1 = require("./form-element-base");
exports.defaultValues = __assign({}, form_element_base_1.defaultValues, { isRequired: false, readOnly: false, autoComplete: "on", tooltip: '' });
//# sourceMappingURL=form-input-element-base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/form-input-element-base.js
// module id = 1121
// module chunks = 0